import {
  Eye,
  EyeClose,
  Maximize,
  Minimize,
  Target,
  TargetOff,
} from 'assets/icons';

import './styles.scss';
import { useState } from 'react';
import { SettingControl } from 'components/SettingControl';

export const Actions = ({
  isShowCircle,
  onToggleCircle,
  isHighlight,
  onToggleHighlight,
}) => {
  const [isFullscreen, setIsFullscreen] = useState(
    !!document.fullscreenElement
  );

  function goFullscreen() {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
  }

  function toggleFullscreen(element) {
    if (!document.fullscreenElement) {
      setIsFullscreen(true);
      goFullscreen(element);
    } else {
      setIsFullscreen(false);
      exitFullscreen();
    }
  }

  return (
    <div className="actions-container">
      <button className="action-btn" onClick={onToggleHighlight}>
        {!isHighlight ? <EyeClose /> : <Eye />}
      </button>
      <button className="action-btn" onClick={onToggleCircle}>
        {isShowCircle ? <TargetOff /> : <Target />}
      </button>
      <button
        className="action-btn"
        onClick={() => toggleFullscreen(document.documentElement)}
      >
        {isFullscreen ? <Minimize /> : <Maximize />}
      </button>
      <SettingControl className="action-btn" />
    </div>
  );
};
